import { useEffect, useMemo, useState } from 'react'

import cn from 'clsx'

import s from './styles.module.scss'

const icons = import.meta.glob('@Static/images/market_icons/*.svg', { as: 'url' })

const iconIndex: Record<string, string> = Object.keys(icons).reduce((acc, key) => {
  const fileName = key.split('/').pop()
  if (fileName) acc[fileName] = key
  return acc
}, {} as Record<string, string>)

type Props = {
  symbol?: string
  source_currency?: string
  target_currency?: string
  className?: string
  alt?: string
}

export const MarketIcon = ({ symbol, className, alt }: Props) => {
  const source = symbol ?? ''

  const [url, setUrl] = useState<string | null>(null)
  const singleFile = useMemo(() => (source ? `${source}.svg` : null), [source])

  useEffect(() => {
    let cancelled = false

    const tryLoad = async (fileName: string | null) => {
      if (!fileName) return null
      const key = iconIndex[fileName]
      if (!key) return null
      return await icons[key]()
    }

    const load = async () => {
      setUrl(null)

      const url = await tryLoad(singleFile)
      if (url && !cancelled) return setUrl(url)

      if (!cancelled) setUrl(null)
    }

    load()
    return () => {
      cancelled = true
    }
  }, [singleFile])

  if (!url) return null

  return <img className={cn(s.icon, className)} src={url} alt={alt ?? symbol} />
}
